import { wsService } from "../wsService";

const section = "sellers";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function get(param = {}) {
  return wsService.make_post_request(section + "/get", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

export const sellersService = {
  section,
  filter,
  get,
  remove,
  create,
  update,
};
